import { c as _c } from "react/compiler-runtime";
import { StaticRadioButton } from '@systemeio/components';
import { Laptop01Icon, PackageIcon } from '@systemeio/icons';
import { CurrencyEnum } from '@systemeio/types';
import { DigitalProductAddModal } from 'modules/digital-product/components/digital-product-add-modal';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { DigitalProductChangeInterface } from 'modules/digital-product/types/digital-product-interface';
import { OfferConfigurationCard } from 'modules/funnels/funnel/components/step-configuration-tab/offer-configuration-card';
import { PhysicalProductId } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import { AddPhysicalProductModal } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/components/add-physical-product-modal';
import { OfferTypeEnum } from 'modules/funnels/funnel/enums/offer-type-enum';
import React from 'react';
import { SectionMessage } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
import { twJoin } from 'tailwind-merge';
interface OfferProductTypeSelectorProps {
  type: OfferTypeEnum | undefined;
  currency: CurrencyEnum;
  isBump?: boolean;
  onAddDigital: (product: DigitalProductChangeInterface) => void;
  onAddPhysical: (product: PhysicalProductId) => void;
  hasDigitalProduct: boolean;
  hasPhysicalProduct: boolean;
}
const OfferProductTypeSelector = t0 => {
  const $ = _c(71);
  const {
    type,
    isBump,
    onAddDigital,
    onAddPhysical,
    hasDigitalProduct,
    hasPhysicalProduct,
    currency
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    opened: openedPhysical,
    close: onClosePhysical,
    open: onOpenPhysical
  } = useModal();
  const {
    opened: openedDigital,
    close: onCloseDigital,
    open: onOpenDigital
  } = useModal();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.offer.choose_offer_type");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-text-tertiary text-sm font-medium uppercase">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onOpenDigital) {
    t3 = () => onOpenDigital();
    $[4] = onOpenDigital;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = type === OfferTypeEnum.digital;
  const t5 = type === OfferTypeEnum.digital && "border-border-accent";
  let t6;
  if ($[6] !== t5) {
    t6 = twJoin("focus-visible:focus-ring-primary transition-base w-full text-start disabled:cursor-not-allowed", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== hasDigitalProduct || $[9] !== t3 || $[10] !== t4 || $[11] !== t6) {
    t7 = <button onClick={t3} disabled={hasDigitalProduct} aria-pressed={t4} className={t6} type="button" />;
    $[8] = hasDigitalProduct;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Laptop01Icon />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("dashboard.funnel.configuration.offer.digital_product");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("dashboard.digital_product.description");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = type === OfferTypeEnum.digital;
  let t12;
  if ($[18] !== t11) {
    t12 = <StaticRadioButton checked={t11} />;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t7 || $[23] !== t9) {
    t13 = <OfferConfigurationCard render={t7} icon={t8} title={t9} description={t10} action={t12} />;
    $[20] = t10;
    $[21] = t12;
    $[22] = t7;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== onOpenPhysical) {
    t14 = () => onOpenPhysical();
    $[25] = onOpenPhysical;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = type === OfferTypeEnum.physical;
  const t16 = type === OfferTypeEnum.physical && "border-border-accent";
  let t17;
  if ($[27] !== t16) {
    t17 = twJoin("focus-visible:focus-ring-primary transition-base w-full text-start disabled:cursor-not-allowed", t16);
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== hasPhysicalProduct || $[30] !== t14 || $[31] !== t15 || $[32] !== t17) {
    t18 = <button onClick={t14} disabled={hasPhysicalProduct} aria-pressed={t15} className={t17} type="button" />;
    $[29] = hasPhysicalProduct;
    $[30] = t14;
    $[31] = t15;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <PackageIcon />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t) {
    t20 = t("dashboard.funnel.configuration.offer.physical_product");
    $[35] = t;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("dashboard.funnel.configuration.offer.physical_product_description-2");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  const t22 = type === OfferTypeEnum.physical;
  let t23;
  if ($[39] !== t22) {
    t23 = <StaticRadioButton checked={t22} />;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t18 || $[42] !== t20 || $[43] !== t21 || $[44] !== t23) {
    t24 = <OfferConfigurationCard render={t18} icon={t19} title={t20} description={t21} action={t23} />;
    $[41] = t18;
    $[42] = t20;
    $[43] = t21;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t13 || $[47] !== t24) {
    t25 = <div className="tablet:flex-row flex w-full flex-col gap-2">{t13}{t24}</div>;
    $[46] = t13;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t || $[50] !== type) {
    t26 = !type && <SectionMessage title={t("dashboard.funnel.configuration.offer.hint.title")}>{t("dashboard.funnel.configuration.offer.hint.description")}</SectionMessage>;
    $[49] = t;
    $[50] = type;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t2 || $[53] !== t25 || $[54] !== t26) {
    t27 = <div className="flex flex-col gap-4">{t2}{t25}{t26}</div>;
    $[52] = t2;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== currency || $[57] !== isBump || $[58] !== onAddDigital || $[59] !== onCloseDigital || $[60] !== openedDigital) {
    t28 = <DigitalProductAddModal opened={openedDigital} onAdd={onAddDigital} currency={currency} isBump={isBump} source={DigitalProductSourceEnum.Funnel} onClose={onCloseDigital} />;
    $[56] = currency;
    $[57] = isBump;
    $[58] = onAddDigital;
    $[59] = onCloseDigital;
    $[60] = openedDigital;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== currency || $[63] !== onAddPhysical || $[64] !== onClosePhysical || $[65] !== openedPhysical) {
    t29 = <AddPhysicalProductModal opened={openedPhysical} onAdd={onAddPhysical} currency={currency} onClose={onClosePhysical} />;
    $[62] = currency;
    $[63] = onAddPhysical;
    $[64] = onClosePhysical;
    $[65] = openedPhysical;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t27 || $[68] !== t28 || $[69] !== t29) {
    t30 = <>{t27}{t28}{t29}</>;
    $[67] = t27;
    $[68] = t28;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  return t30;
};
export default OfferProductTypeSelector;